export default "__VITE_ASSET__DHQxut1q__"